import hasPreviousCounters from "./hasPreviousCounters";
//-------------------
// is counter action
//-------------------
export default async function isCounterAction(parm) {
  console.log("--------------------------");
  console.log("IN isCounterAction");
  return new Promise((resolve, reject) => {
    //--------------------------------------------------------------
    // where:
    // (a) not on counters OR
    // (b) on counters BUT action is remove counter (and is latest)
    // (c) on counters BUT marker is counter
    //--------------------------------------------------------------
    //--------------------
    // no counters at all
    //--------------------
    if (!parm.counters) {
      console.log("isCounterAction1");
      resolve(true);
      //-----------------------------------------------------
      // new action is remove counters - check prev counters
      //-----------------------------------------------------
    } else if (
      parm.selected_action &&
      parm.selected_action.name == "remove_counter"
    ) {
      console.log("isCounterAction2");
      //----------
      // set parm
      //----------
      let previous_parm = {
        id: parm.id,
        round: parm.round,
        num: parm.num,
      };
      //-----------------------------
      // check for previous counters
      //-----------------------------
      let call = hasPreviousCounters(previous_parm);
      call
        .then((previousCounters) => {
          //-----------------------
          // has previous counters
          //-----------------------
          if (previousCounters) {
            // console.log("isCounterAction3");
            resolve(false);
            //----------------------
            // no previous counters
            //----------------------
          } else {
            // console.log("isCounterAction4");
            resolve(true);
          }
        })
        .catch((err) => {
          reject(err);
        });
      //---------------
      // is new marker
      //---------------
    // } else if (parm.selected_marker && parm.selected_marker.name == "counter") {
    } else if (parm.selected_marker) {
      // console.log("isCounterAction5");
      resolve(true);
      //---------
      // default
      //---------
    } else {
      // console.log("isCounterAction6");
      resolve(false);
    }
  });
}
